import Screenshots from './how-to/Screenshots';

export default function HowTo() {
  return (
    <main className="container mx-auto mb-auto">
      <Screenshots />
    </main>
  );
}
